import { groupBy, map, mapValues, reduce, set } from 'lodash';

import ACTIONS from 'state/constants';
import CollectionPage from 'state/selectors/collection-page';
import { COLLECTION_PAGE_FILTER_IDENTIFIERS } from 'utils/Filters';
import { replaceHistory, parseQueryString } from 'utils/Url';

const setStatefulCollectionFilterUrlParams = state => {
  // Get current URL params
  const currentUrlParams = parseQueryString();

  // Come up with exhaustive list of collection filter URL params. This will be used to blank out all collection filter URL params
  const allPossibleCollectionFilterUrlParams = reduce(
    COLLECTION_PAGE_FILTER_IDENTIFIERS,
    (result, filterIdentifier) => set(result, filterIdentifier, undefined),
    {}
  );

  // Come up with new list of collection filter url params
  const appliedFilterOptions = CollectionPage.getAppliedFilterOptions(state);
  const groupedFilterOptions = groupBy(appliedFilterOptions, 'filterIdentifier');
  const newCollectionFilterUrlParams = mapValues(groupedFilterOptions, filterItem =>
    map(filterItem, 'option')
  );

  // This takes all the URL params, and only overwrites the url params that relate to collection filters. It should leave any other unrelated param unchanged
  const newUrlParams = {
    ...currentUrlParams,
    ...allPossibleCollectionFilterUrlParams,
    ...newCollectionFilterUrlParams,
  };

  replaceHistory(newUrlParams, null);
};

const CollectionPageUrlUpdater = store => next => action => {
  next(action);

  const state = store.getState();

  switch (action.type) {
    case ACTIONS.SET_COLLECTION_PAGE_FILTER:
    case ACTIONS.CLEAR_COLLECTION_PAGE_FILTERS:
      setStatefulCollectionFilterUrlParams(state);
      break;
    default:
      break;
  }
};

export default CollectionPageUrlUpdater;
